// Note: This is UK English
import { Lang } from "./no";

export const en: Lang = {
  locale: "en",

  Main: {
    title: "Your profile",
    description:
      "Manage and review your personal information and account preferences.",
    edit: "Edit",
    logout: "Log out",
  },

  AccountPreferences: {
    title: "Account preferences",
    description: "Adjust settings related to your account.",
  },

  DeleteUser: {
    title: "Delete user account",
    description:
      "Permanently delete this user account. This action can not be undone",
    editLabel: "Delete user account",
  },

  DeleteUserDialog: {
    title: "Delete user account",
    description:
      "Are you sure you want to delete this user account? This action cannot be undone.",
    deleted_description:
      "You have deleted your account, and have no access to this page anymore.",
    cancel: "Cancel",
    submitLabel: "Delete account",
    saveError:
      "An error has occurred while deleting your account. Please try again later.",
  },

  Details: {
    title: "Details",
    description: "Manage your personal information.",
  },

  EditNameDialog: {
    title: "Change name",
    description: "Please enter your new name below.",
    firstNameLabel: "First name",
    lastNameLabel: "Last name",
    cancel: "Cancel",
    submitLabel: "Change name",
    saveError:
      "An error has occurred while changing your name. Please try again later.",
  },

  Profile: {
    title: "Your profile information",
    description: "This is you.",
    nameLabel: "Name",
    emailLabel: "E-mail",
  },

  LoginDialog: {
    title: "User profile",
    // description:
    //   "Log in to change contact-information or to delete your account",
    email: "E-mail",
    password: "Password",
    login: "Log in",
    loginError: "Could not log in with the provided credentials.",
    sessionExpired: "Your session has expired, and you have been logged out",
    switchUser: "Switch user",
    loggedInAs: "Logged in as: ",
  },
};

export default en;
